import { idAndNameModel, Platform, UserActionTimestamps } from '../common';
import { ActionTypes } from './actions/actionTypes.enum';
import { TriggerTypes } from './triggers/triggerTypes.enum';

export interface PlaybookTriggerConfigBase {}
export interface PlaybookActionDefinitionPropertiesBase {}

export interface PlaybookTrigger {
  triggerType: TriggerTypes;
  configuration: PlaybookTriggerConfigBase;
}

export interface PlaybookAction {
  actionType: ActionTypes;
  actionDefinitionProperties: PlaybookActionDefinitionPropertiesBase;
}

export interface AnyPlaybookActionDefinition {}

export enum PlaybookStatus {
  active = 'active',
  disabled = 'disabled',
}

export enum ExecutionCalculatedStatus {
  success = 'success',
  warning = 'warning',
}

export enum ActionsResponse {
  success = 'success',
  edit = 'edit',
  template = 'template',
  new = 'new',
  loading = 'loading',
}

export interface Playbook {
  id: string;
  name: string;
  description: string;
  trigger: PlaybookTrigger;
  actions: PlaybookAction[];
  platform: Platform;
  policies: idAndNameModel[];
  integration: idAndNameModel;
  status: PlaybookStatus;
  userActionTimestamps: UserActionTimestamps;
  executionCalculatedStatus?: ExecutionCalculatedStatus;
  lastExecutionAt?: Date;
}
